import { z } from 'zod';

/** One admin bank account from GET /v2/admin/bank_details. */
export const adminBankDetailsSchema = z.object({
  id: z.string(),
  country: z.string(),
  bank_name: z.string().nullable(),
  account_number_last4: z.string().nullable(),
  account_number: z.string().nullable(),
  account_type: z.string().nullable(),
  account_holder_name: z.string().nullable(),
  account_holder_type: z.string().nullable(),
  routing_number_last4: z.string().nullable(),
  routing_number: z.string().nullable(),
  is_primary: z.boolean(),
});

export const adminBankDetailsListSchema = z.array(adminBankDetailsSchema);

export type AdminBankDetails = z.infer<typeof adminBankDetailsSchema>;
